import { DepartmentLabel } from '@Map/FloorMap/Components/MapPage/MapPageContent/Components/DepartmentLabel';
import { MapGrid } from '@Map/shared/MapGrid';
import { MapPointer } from '@Map/shared/MapPointer';
import { transformPoint } from '@Utils/3d';
import { utilStyles } from '@Utils/utilStyles';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { View } from 'react-native';

import { useMapPagePresenter } from '../../MapPagePresenter';

export const MapLayout = observer(function MapLayout() {
  const {
    navToFloor,
    floorId,
    scaledDepartmentsBox,
    containerSize: containerSizeInPresenter,
    currentFloor,
    scaleAspectRatio,
    rootFloorId,
    labelBoxes,
    floorCameraPosition: cameraPosition,
    floorLayoutSize, // this is needed purely for floor marker
  } = useMapPagePresenter();

  const onPress = (departmentId: number) => {
    if (!floorId.value) {
      throw new Error(
        'Floor Map Error: Floor Id missing while attempted to move to floor'
      );
    }

    navToFloor(floorId.value, departmentId);
  };

  const { width, height } = scaledDepartmentsBox;

  const { x, y } = transformPoint(
    floorLayoutSize ?? { width: 0, height: 0 }, // will normally display on top left corner, but we don't display it.
    {
      width,
      height,
    },
    cameraPosition && {
      x: cameraPosition.x,
      y: cameraPosition.y,
    }
  );

  const radiusRatio = 0.8; // 100/125;
  const radius = Math.min(scaleAspectRatio * radiusRatio, 50);

  return (
    <View
      style={[
        utilStyles.height100pc,
        utilStyles.width100pc,
        utilStyles.alignItemsCenter,
        utilStyles.justifyContentCenter,
      ]}
      onLayout={(event) => {
        containerSizeInPresenter.set({
          width: event.nativeEvent.layout.width,
          height: event.nativeEvent.layout.height,
        });
      }}
    >
      <View style={{ width, height }}>
        <MapGrid cellSize={scaleAspectRatio} borderRadius={radius} />
        {labelBoxes.map((area) => (
          <DepartmentLabel
            key={area.departmentId}
            onPress={() => {
              onPress(area.departmentId);
            }}
            area={area}
            scaleAspectRatio={scaleAspectRatio}
          />
        ))}
        {rootFloorId === currentFloor?.id && floorLayoutSize && (
          <MapPointer x={x} y={y} size={23} />
        )}
      </View>
    </View>
  );
});
